import { z } from 'zod'
import type { EduAgreementStateFilterV4NameKey } from '@/shared/api/generated/models/EduAgreementStateFilterV4Name'

export const agreementStatusFilters = [
  'toSignEdu',
  'toSignIntern',
  'toSignOrg',
  'inProcess',
  'missingData',
  'missingOrg',
  'signed',
] as const satisfies readonly EduAgreementStateFilterV4NameKey[]

export const agreementSearchSchema = z.object({
  status: z
    .enum(['all', 'toSignEdu', 'toSignOther', 'inProcess', 'missingData', 'signed'])
    .catch('all'),
  search: z.string().max(200).optional().catch(undefined),
  classId: z.string().optional().catch(undefined),
  groupIds: z.array(z.string()).optional().catch(undefined),
  internshipIds: z.array(z.string()).optional().catch(undefined),
  templateId: z.string().optional().catch(undefined),
  agreementStatus: z.enum(agreementStatusFilters).optional().catch(undefined),
  nrPrefix: z.string().max(50).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum(['nr', 'intern', 'org', 'eduSigned', 'orgSigned', 'internSigned', 'status'])
    .catch('nr'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type AgreementSearch = z.infer<typeof agreementSearchSchema>

export type AgreementInternshipScope = {
  internshipId: string
  classId?: string
}

export const defaultAgreementSearch: AgreementSearch = {
  status: 'all',
  page: 1,
  pageSize: 10,
  sortBy: 'nr',
  direction: 'asc',
}
